<template>
    <div class='photobuy-main'>
        <div class='title'>
            <p class='event-title'> {{ event.school_name + ' ' + event.year_name + ' ' + event.name }} の写真一覧 </p>
            <p class='photoCount'> {{ totalPhotoCount }} 件 </p>
        </div>
        <div class='tabs is-midium is-boxed'>
            <ul>
                <li @click='changeMode("photoList")' v-bind:class='{ "is-active": photoList }'>
                    <a>
                        <span class='icon is-small'><i class='fas fa-image' aria-hidden='true'></i></span>
                        <span>写真一覧</span>
                    </a>
                </li>
                <!-- <li @click='changeMode("eventList")' v-bind:class='{ "is-active": eventList }'>
                    <a>
                        <span class='icon is-small'><i class="fas fa-calendar"></i></span>
                        <span>行事一覧</span>
                    </a>
                </li> -->
            </ul>
        </div>
        <div class='photobuy-main-content'>
            <PhotoList
                v-if='photoList'
                :photos='photos'
                :cartMap='cartMap'
                :sizes='sizes'
                :defaultSize='defaultSize'
                :loading='loading'
                :hasMore='hasMore'
                :loadingMore='loadingMore'
                :hasNamedHuman='hasNamedHuman'
                @load-more='fetchPhotos()'
                @change-photo='updatePhoto'
            ></PhotoList>
            <!-- <eventList v-if='eventList'></eventList> -->
        </div>
    </div>
</template>

<script>

import PhotoList from '@/components/photobuy/pages/PhotoList.vue'
import { resolveDefaultSize } from '@/helpers/printSize'
// import EventList from '@/components/photobuy/pages/EventManage.vue'

export default {
    name: 'PhotobuyMain',
    props: ['cartMap'],
    components: {
        PhotoList
    },
    data () {
        return {
            event: {
                school_name: '',
                year_name: '',
                name: ''
            },
            photos: [],
            sizes: [],
            defaultSize: '',
            photoList: true,
            eventList: false,
            loading: true,
            loadingMore: false,
            hasMore: true,
            page: 1,
            pageSize: 60,
            totalPhotoCount: 0,
            hasNamedHuman: false
        }
    },
    mounted () {
        this.fetchPhotos(true)
    },
    methods: {
        normalizePhotos (photos) {
            return photos.map((photo) => {
                const cartPhoto = this.cartMap[photo.id]
                return {
                    ...photo,
                    size: cartPhoto ? cartPhoto.size : this.defaultSize,
                    length: cartPhoto ? cartPhoto.length : 1
                }
            })
        },
        fetchPhotos (reset = false) {
            if (this.loadingMore) return

            if (reset) {
                this.loading = true
                this.loadingMore = false
                this.page = 1
                this.hasMore = true
                this.photos = []
            } else if (!this.hasMore) {
                return
            } else {
                this.loadingMore = true
            }

            this.axios.get(`${process.env.API_URL}/photobuy`, {
                params: {
                    id: this.$route.params.id,
                    page: this.page,
                    limit: this.pageSize
                }
            }).then((res) => {
                if (res.data.message === 'unauthenticated') {
                    this.$router.push('/login')
                    return
                }

                if (res.data.message === 'wrong') {
                    alert('指定したページが存在しないかアクセス権がありません')
                    this.$router.push('/mypage')
                    return
                }

                this.event = res.data.event
                this.sizes = res.data.setting.sizes
                this.defaultSize = resolveDefaultSize(this.sizes, res.data.setting.defaultSize)
                this.totalPhotoCount = res.data.totalCount
                this.hasMore = res.data.hasMore
                this.hasNamedHuman = !!res.data.hasNamedHuman

                const normalizedPhotos = this.normalizePhotos(res.data.photos)
                this.photos = reset ? normalizedPhotos : this.photos.concat(normalizedPhotos)
                this.page++

                const now = new Date()
                const startDate = new Date(this.event.sales_start_date)
                const endDate = new Date(this.event.sales_end_date)
                endDate.setDate(endDate.getDate() + 1)

                if (!this.event.sales_outside_period && (now < startDate || now > endDate)) {
                    alert('販売期間外です マイページに戻ります')
                    this.$router.push('/photobuy/mypage')
                }
            }).catch(() => {
                alert('サーバーに問題が発生しています')
            }).finally(() => {
                this.loading = false
                this.loadingMore = false
            })
        },
        changeMode (mode) {
            this.$data.photoList = false
            this.$data.eventList = false

            if (mode === 'photoList') {
                this.$data.photoList = true
            } else if (mode === 'eventList') {
                this.$data.eventList = true
            }
        },
        updatePhoto ({ id, size, length }) {
            this.photos = this.photos.map((photo) => {
                if (photo.id !== id) return photo
                return { ...photo, size, length }
            })
        }
    }
}
</script>

<style scoped>

.photobuy-main {
    width: 100%;
    flex: 1;
    max-width: 1280px;
    min-height: calc(100vh - 80px);
    margin: auto;
    overflow-x: hidden;
}

.tabs {
    margin: 0 auto;
    width: 100%;
    max-width: 1280px;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
}

.photobuy-main-content {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
}

.mode-change {
    font-size: 20px;
    font-weight: bold;
    color: rgb(77, 139, 255);
    cursor: pointer;
}

.title {
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 20px;
    margin-bottom: 12px;
}

.event-title {
    font-size: 23px;
    font-weight: bold;
}

.photoCount {
    margin-top: 10px;
    margin-left: 8px;
    font-size: 15px;
    font-weight: 400;
}

@media (max-width: 600px) {
    .photobuy-main-content {
        padding-left: 8px;
        padding-right: 8px;
    }

    .title {
        padding-left: 8px;
        padding-right: 8px;
        margin-top: 10px;
        margin-bottom: 8px;
    }

    .event-title {
        font-size: 16px;
    }

    .tabs {
        padding-left: 8px;
        padding-right: 8px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/photobuy/pages/Main.vue